import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { appConfig } from './core/config/app.config';
import { CoreModule } from './core/core.module'
import { LayoutModule } from '@angular/cdk/layout';
import { mockApiServices } from './mock-api';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CookieService } from 'ngx-cookie-service';
import { HttpRequestInterceptor } from './interceptors/httprequest.interceptor';
import { PermissionsInterceptor } from './interceptors/permissions.interceptor';
import {provideNgxMask } from 'ngx-mask';
import { ENVIRONMENT_INJECTION_TOKEN } from '@sbd-doug-frontend/shared/lib/injections/environment-injection-token';
import { environment } from '@sbd-doug-frontend/app/environments/environment';
import { MainDrawerComponent } from '@sbd-doug-frontend/app/modules/main-drawer/main-drawer.component';
import {
  QUOTE_REQUESTS_LIST_SERVICE_TOKEN
} from '@sbd-doug-frontend/shared/lib/shared-services/quote-requests-list.abstract.service';
import { DougQuoteRequestsListService } from './modules/quote/quote-requests-list.service';
import { AccountFilesService } from '@sbd-doug-frontend/shared/lib/shared-services/account-files.service';
import { DougAccountFilesService } from '@sbd-doug-frontend/app/modules/accounts/accounts-manager/account-list/account-manager-vtabs/account-manager-email/doug-account-files.service';
import { PERMISSIONS_SOURCE } from '@sbd-doug-frontend/shared/lib/injections/permissions-source-injection-token';
import { UserService } from '@sbd-doug-frontend/app/core/user/user.service';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    RouterModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),
    CoreModule,
    LayoutModule,
    MainDrawerComponent,
  ],
  providers: [
    // Http Interceptor(s) - Adds withCredentials to requests because of cookies.
    [
      { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: PermissionsInterceptor, multi: true },
      provideNgxMask(),
      { provide: ENVIRONMENT_INJECTION_TOKEN, useValue: environment },
      { provide: QUOTE_REQUESTS_LIST_SERVICE_TOKEN, useExisting: DougQuoteRequestsListService },
      { provide: ENVIRONMENT_INJECTION_TOKEN, useValue: environment },
      { provide: AccountFilesService, useClass: DougAccountFilesService },
      {
        provide: PERMISSIONS_SOURCE,
        useFactory: (userService: UserService) => () =>
          userService.currentAdmin()?.permissions ?? [],
        deps: [UserService],
      }
    ],
    CookieService,
    Title
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
